import Container from 'react-bootstrap/Container';
import LoginPage from './components/login/LoginPage';
import Header from './components/Header';
import Footer from './components/Footer';
import ResetPassword from './components/ResetPassword';
import { Routes, Route, useLocation } from 'react-router-dom';
import Competitions from './organizer/Competitions/Competitions';
import React, { createContext, useEffect, useState } from 'react';
import {
  checkIfAuthenticated,
  checkTokenExpiration,
  getUser,
  getUserRole,
} from './utils/Authentication';
import PrivateRoute from './components/PrivateRoute';
import CompetitionDetails from './organizer/Competitions/CompetitionDetails';
import CompetitionRegistrations from './organizer/Competitions/Registrations/CompetitionRegistrations';
import AdminHome from './admin/AdminHome';
import EditProfile from './organizer/editProfile/EditProfile';
import CompetitionVehicles from './organizer/Competitions/vehicles/CompetitionVehicles';
import CompetitionBiddings from './organizer/Competitions/biddings/CompetitionBiddings';
import CompetitionStartlist from './organizer/Competitions/startlist/CompetitionStartlist';
import CompetitionResult from './organizer/Competitions/result/CompetitionResult';
import CompetitionAmendment from './organizer/Competitions/amendment/CompetitionAmendment';
import CompetitionBoard from './organizer/Competitions/board/CompetitionBoard';
import { interceptor } from './api/Intercept';
import OrganizerAdmins from './organizer/users/OrganizerUsers';
import { getOrganizerUser } from './api/User';
import IntergrityPolicy from './organizer/information/IntegrityPolicy'
import DeleteAccount from './organizer/information/DeleteAccount'

export const UserContext = createContext();

function App() {
  const [user, setUser] = useState({});
  const [headerType, setHeaderType] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    interceptor();
    checkTokenExpiration();
    const role = getUserRole();

    async function fetchUser() {
      const authenticated = checkIfAuthenticated(role);
      setIsAuthenticated(authenticated);

      if (authenticated && Object.keys(user).length === 0) {
        let user;
        if (role === 'organizerprofile') {
          user = await getOrganizerUser();
        } else {
          user = await getUser();
        }
        setUser(user);
        setHeaderType(role);
      }
    }

    fetchUser();
  }, []);

  const loginPages = [
    '/',
    '/admin',
    '/admin/',
    '/admin/resetpassword',
    '/admin/resetpassword/',
    '/organizer',
    '/organizer/',
    '/organizer/resetpassword',
    '/organizer/resetpassword/',
    '/participant/resetpassword',
  ];

  return (
    <UserContext.Provider value={{ user, setUser }}>
      <Container fluid className='p-0 vh-100 d-flex flex-column'>
        {!loginPages.includes(location.pathname) ? (
          <Header
            isAuthenticated={isAuthenticated}
            setIsAuthenticated={setIsAuthenticated}
            type={headerType}
            setHeaderType={setHeaderType}
          />
        ) : (
          <></>
        )}
        <main
          className={
            'p-3 p-md-5 mb-3 flex-grow-1 d-flex flex-column ' +
            (loginPages.includes(location.pathname)
              ? 'justify-content-center'
              : '')
          }
        >
          <Routes>
            <Route
              path='/admin'
              element={
                <LoginPage
                  role='admin'
                  isAuthenticated={isAuthenticated}
                  setHeaderType={setHeaderType}
                  setIsAuthenticated={setIsAuthenticated}
                />
              }
            />
            <Route
              path='/organizer'
              element={
                <LoginPage
                  role='organizer'
                  isAuthenticated={isAuthenticated}
                  setHeaderType={setHeaderType}
                  setIsAuthenticated={setIsAuthenticated}
                />
              }
            />
            <Route path=':role/resetpassword' element={<ResetPassword />} />

            <Route element={<PrivateRoute role='admin' />}>
              <Route path='/admin/home' element={<AdminHome />} />
            </Route>

            <Route element={<PrivateRoute role='organizer' />}>
              <Route path='/organizer/profile' element={<EditProfile />} />
              <Route
                path='/organizer/administrators'
                element={<OrganizerAdmins />}
              />
            </Route>
            <Route
              element={
                <PrivateRoute role={['organizer', 'organizerprofile']} />
              }
            >
              <Route
                path='/organizer/competitions'
                element={<Competitions />}
              />
              <Route
                path='/organizer/competitions/:id/details'
                element={<CompetitionDetails />}
              />
              <Route
                path='/organizer/competitions/:id/registrations'
                element={<CompetitionRegistrations />}
              />
              <Route
                path='/organizer/competitions/:id/startlist'
                element={<CompetitionStartlist />}
              />
              <Route
                path='/organizer/competitions/:id/vehicles'
                element={<CompetitionVehicles />}
              />
              <Route
                path='/organizer/competitions/:id/biddings'
                element={<CompetitionBiddings />}
              />
              <Route
                path='/organizer/competitions/:id/result'
                element={<CompetitionResult />}
              />
              <Route
                path='/organizer/competitions/:id/amendment'
                element={<CompetitionAmendment />}
              />
              <Route
                path='/organizer/competitions/:id/board'
                element={<CompetitionBoard />}
              />
            </Route>
            <Route path='/integritypolicy' element={<IntergrityPolicy />} />
            <Route path='/deleteaccount' element={<DeleteAccount/>} />
          </Routes>
        </main>
        <Footer />
      </Container>
    </UserContext.Provider>
  );
}

export default App;
